export const firebaseConfig = {
  apiKey: 'AIzaSyBGfvWt7lzcVDtKUVGhnxxcnUQU-sT-ans',
  authDomain: 'cookingsite-c2d05.firebaseapp.com',
  databaseURL: 'https://cookingsite-c2d05.firebaseio.com',
  projectId: 'cookingsite-c2d05',
  storageBucket: 'cookingsite-c2d05.appspot.com',
  messagingSenderId: '919564290361',
}
